<template>
  <div>
    <table-manager @filterChanged="filterChanged"
     @paginationChanged="paginationChanged"
     @sort-changed="sortingChanged"
     :options="options"/>

    <basic-table
      v-if="deletedUsers"
      :items="deletedUsers"
      :fields="userGroupsFields"
      :filter="filter"
      :perPage="perPage"

      @ClickOnEditButton="askRestoreUser"
      v-model="totalRows"
      isEdit="true"/>

      <TableManagerBottom style="margin:5px" id="pagination" ref="pagination"
      :totalRows="totalRows"
      :perPage="perPage"
      @input="changePage"
      v-model="currentPage"/>
  </div>
</template>

<script>
import TableManagerBottom from '@/components/tables/TableManagerBottom'
export default {
  components: {
    TableManagerBottom
  },
  data () {
    return {
      isEdit: null,
      userGroupsFields: [
        { key: 'user_id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'login', label: this.$i18n.t('Login'), sortable: true },
        { key: 'basic_account', label: this.$i18n.t('Basic account'), sortable: true },
        { key: 'full_name', label: this.$i18n.t('FullName'), sortable: true },
        { key: 'email', label: this.$i18n.t('Email') },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      options: {
        isShowAddButton: false
      },
      filter: '',
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      sort_field: 'user_id',
      is_desc: false
    }
  },
  methods: {
    changePage (numPage) {
      this.currentPage = numPage
    },
    sortingChanged (ctx) {
      this.$refs.pagination.setCurrentPage(1)
      this.sort_field = ctx.sortBy
      this.is_desc = ctx.sortDesc
      this.currentPage = 1
      this.$store.dispatch('Users/SEARCH_DELETED_USERS', {
        page: this.currentPage,
        value: this.filter,
        per_page: this.perPage,
        sort_field: this.sort_field,
        is_desc: this.is_desc
      })
    },
    filterChanged (value) {
      this.$refs.pagination.setCurrentPage(1)
      this.currentPage = 1
      this.filter = value
      this.$store.dispatch('Users/SEARCH_DELETED_USERS', {
        page: 1,
        value: this.filter,
        per_page: this.perPage,
        sort_field: this.sort_field,
        is_desc: this.is_desc
      })
    },
    async paginationChanged (value) {
      this.perPage = value
      if (this.$refs.pagination) this.$refs.pagination.setCurrentPage(1)
      if (this.currentPage === 1) {
        await this.$store.dispatch('Users/SEARCH_DELETED_USERS', {
          page: this.currentPage,
          value: this.filter,
          per_page: this.perPage,
          sort_field: this.sort_field,
          is_desc: this.is_desc
        }).then(el => {
          this.totalRows = this.$store.getters['Users/DELETED_USERS'].total_rows
        })
      }
      this.currentPage = 1
    },
    askRestoreUser (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure want to restore user?'), this.restoreUser, item)
    },
    restoreUser (item) {
      let userToRestore = JSON.parse(JSON.stringify(item))
      let tmp = {
        user_id: userToRestore.user_id
      }
      let response = this.$store.dispatch('Users/RESTORE_USERS', tmp)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Users/SEARCH_DELETED_USERS', {
            page: this.currentPage,
            value: this.filter,
            per_page: this.perPage,
            sort_field: this.sort_field,
            is_desc: this.is_desc
          })
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  watch: {
    currentPage: async function (val) {
      await this.$store.dispatch('Users/SEARCH_DELETED_USERS', {
        page: val,
        value: this.filter,
        per_page: this.perPage,
        sort_field: this.sort_field,
        is_desc: this.is_desc
      }).then(el => {
        this.totalRows = this.$store.getters['Users/DELETED_USERS'].total_rows
      })
      this.$refs.pagination.setCurrentPage(val)
    },
    deletedUsers: function (val) {
      this.totalRows = this.$store.getters['Users/DELETED_USERS'].total_rows
    }
  },
  computed: {
    deletedUsers () {
      return this.$store.getters['Users/DELETED_USERS'].users
    }
  },
  mounted () {
    this.$refs.pagination.setCurrentPage(1)
    this.currentPage = 1
    this.$store.dispatch('Users/SEARCH_DELETED_USERS', {
      page: 1,
      value: '',
      per_page: this.perPage,
      sort_field: this.sort_field,
      is_desc: this.is_desc
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/deletedUsers/main.vue